import { AdjustmentAmountOption } from "@redotech/redo-model/return-flow/condition";
import { ConditionTypeDetailsProps } from "@redotech/redo-return-ui/flows/return-flow/condition";
import { AdjustmentAmountState } from "@redotech/redo-return-ui/flows/return-flow/condition-types/adjustment-amount";
import { RedoTextInput } from "@redotech/redo-web/arbiter-components/input/redo-text-input";
import { RedoListItem } from "@redotech/redo-web/arbiter-components/list/redo-list";
import { RedoSingleSelectDropdownInput } from "@redotech/redo-web/arbiter-components/select-dropdown/redo-single-select-dropdown-input";
import { memo, useMemo } from "react";

export const AdjustmentAmountDetails = memo(function AdjustmentAmountDetails({
  state,
  setState,
  disabled,
}: ConditionTypeDetailsProps<AdjustmentAmountState>) {
  const adjustmentAmountOptions: RedoListItem<AdjustmentAmountOption>[] =
    useMemo(
      () =>
        Object.values(AdjustmentAmountOption).map((option) => ({
          id: option,
          value: option,
          type: "text" as const,
          text: option,
        })),
      [],
    );

  const selectedOption = state.adjustmentAmountOption
    ? adjustmentAmountOptions.find(
        (option) => option.value === state.adjustmentAmountOption,
      )
    : undefined;

  return (
    <>
      <RedoSingleSelectDropdownInput
        disabled={disabled}
        flexGrow
        label="Match type"
        options={adjustmentAmountOptions}
        optionSelected={({ item }) =>
          setState({ ...state, adjustmentAmountOption: item.value })
        }
        placeholder="Select match type..."
        selectedItem={selectedOption}
        size="xs"
      />
      <RedoTextInput
        IconLeading={() => <>$</>}
        inputTypeHint="number"
        label="Total adjustment amount of selected items"
        onBlur={() =>
          setState({
            ...state,
            adjustmentAmount: (+state.adjustmentAmount).toFixed(2),
          })
        }
        setValue={(e) => setState({ ...state, adjustmentAmount: e })}
        state={disabled ? "readonly" : "default"}
        value={state.adjustmentAmount}
      />
    </>
  );
});
